import {createContext} from 'react'

import {noop} from '@sdox/utils'

import type {CmsCollectionDocumentFragment} from '@sdox/api'

export type DocumentSelectContextState = {
  selectedDocumentIdentifier?: string
  setSelectedDocument: (document: CmsCollectionDocumentFragment) => void
}

export const DocumentSelectContext = createContext<DocumentSelectContextState>({
  selectedDocumentIdentifier: undefined,
  setSelectedDocument: noop,
})
